import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { LoanCard } from './card-lenses';

const OtherOffer = ({ model, onChange, ...cardProps }) => (
  <Card title="Have you been quoted rates by a lender?" {...cardProps}>
    <BooleanRadioButtons
      name="otherOffer"
      value={model.get('otherOffer')}
      onChange={onChange.bind(null, 'otherOffer')}
    />
  </Card>
);

OtherOffer.id = 'OtherOffer';

OtherOffer.completed = ({ model }) => model.get('otherOffer') != null;

export default LoanCard(OtherOffer);



// WEBPACK FOOTER //
// ./src/cards/other-offer.js